export var RouteType;
(function (RouteType) {
    RouteType[RouteType["Outbound"] = 0] = "Outbound";
    RouteType[RouteType["Return"] = 1] = "Return";
})(RouteType || (RouteType = {}));
